var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.818 9.44c1.537 0 2.782-1.217 2.782-2.72C17.6 5.218 16.355 4 14.818 4c-1.536 0-2.782 1.218-2.782 2.72 0 .282.044.553.125.809l-3.653 2.498a2.81 2.81 0 0 0-1.726-.587C5.245 9.44 4 10.658 4 12.16c0 1.503 1.245 2.72 2.782 2.72.752 0 1.434-.29 1.934-.765l3.445 2.356a2.664 2.664 0 0 0-.125.809c0 1.502 1.246 2.72 2.782 2.72 1.537 0 2.782-1.218 2.782-2.72 0-1.503-1.245-2.72-2.782-2.72-.823 0-1.563.35-2.072.905l-3.41-2.224a2.66 2.66 0 0 0-.122-2.403l3.532-2.303c.51.556 1.249.905 2.072.905Z",
    fill: "#101010"
  })));
};
export default SvgShare;